<ng-container *ngIf="config">
        <mat-icon class="main-icon"
                  (click)="$event.stopPropagation()"
                  [style.color]="config.iconColor"
                  [matMenuTriggerFor]="menu"
        >{{config.iconName || 'info'}}</mat-icon>
    <mat-menu class="info-tooltip" #menu="matMenu" yPosition="below">
        <mat-card class="info-mat-card">
            <mat-card-header class="info-card-header">
                <mat-card-title class="info-card-title">
                    <mat-icon>{{config.headerIcon || 'info'}}</mat-icon>
                    {{config.header}}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content class="info-card-content">
                <p class="info-link-content" [innerHTML]="getLabel(config.content)"></p>
                <div class="info-link">
                    <ng-container *ngFor="let link of config.links">
                        <a *ngIf="link.type === 'faq'" [routerLink]="['/faq']" [queryParams]="{'id' : link.id}">
                            <div class="info-link-message">{{(link.text ? link.text : 'Link to FAQ') | translate}}
                                <mat-icon>quiz</mat-icon>
                            </div>
                        </a>
                        <a *ngIf="link.type === 'user_guide'" target="_blank" [href]="getUserGuideLink(link.id)">
                            <div class="info-link-message">{{(link.text ? link.text : 'Link to User Guide') | translate}}
                                <mat-icon>open_in_new</mat-icon>
                            </div>
                        </a>
                    </ng-container>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-menu>
</ng-container>
